import { Outlet } from 'react-router-dom';

import { Filtering, Pagination, QStack, Sorting } from '@qualio/ui-components';

import { useContext, useEffect } from 'react';
import { useFilterDefinitions } from '../../hooks/UseFilterDefinitions';
import { usePersistanceKey } from '../../hooks/usePersistanceKey';
import { SelectionWrapper } from '../../SelectionWrapper';
import { WorkspaceTabsContext } from '../../WorkspaceTabsContext';
import { WorkspaceTabs } from '../../WorkspaceV2';
import { YourDocumentsTable } from './YourDocumentsTable';

export const YourDocumentsTab = () => {
  const { Provider: PaginationProvider } = Pagination.useLimitOffset();
  const { setCurrentTab } = useContext(WorkspaceTabsContext);
  useEffect(() => {
    setCurrentTab(WorkspaceTabs.YOUR_DOCUMENTS);
  }, [setCurrentTab]);
  const persistanceKey = usePersistanceKey();
  const filterDefinitions = useFilterDefinitions(WorkspaceTabs.YOUR_DOCUMENTS);

  return (
    <QStack direction="column">
      <PaginationProvider>
        <Filtering.FilterProvider
          searchTermKey="query"
          definitions={filterDefinitions}
          persistanceKey={persistanceKey}
        >
          <Sorting.DefaultSortingProvider>
            <SelectionWrapper>
              <YourDocumentsTable />
            </SelectionWrapper>
          </Sorting.DefaultSortingProvider>
        </Filtering.FilterProvider>
      </PaginationProvider>
      <Outlet />
    </QStack>
  );
};
